import { Component, OnInit, Inject } from "@angular/core";
import { ProductService } from "src/app/components/shared/services/product.service";
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { Product } from "src/app/modals/product.model";
import { CartService } from "src/app/components/shared/services/cart.service";
import { Router } from "@angular/router";
import { ItemsService } from "src/app/services/items.service";
import { AlertServiceService } from "src/app/services/alerta.service";

@Component({
  selector: "app-product-dialog",
  templateUrl: "./product-dialog.component.html",
  styleUrls: ["./product-dialog.component.sass"],
})
export class ProductDialogComponent implements OnInit {
  public products: Product[] = [];
  public counter: number = 1;
  public variantImage: any = "";
  public selectedColor: any = "";
  public selectedSize: any = "";

  constructor(
    private router: Router,
    public productsService: ProductService,
    private cartService: CartService,
    public snackBar: MatSnackBar,
    private itemService: ItemsService,
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    private alert: AlertServiceService,
    @Inject(MAT_DIALOG_DATA) public product: Product
  ) {}
  stockInicial: any;
  agotado: boolean = false;
  txtAgotado: string = "Disponible";
  url: any;
  ngOnInit() {
    this.productsService
      .getProducts()
      .subscribe((product) => (this.products = product));
    this.stockInicial = this.product.SaldoG;
    if (this.product.SaldoG == 0) {
      this.txtAgotado = "Agotado";
      this.agotado = true;
    } else {
      this.txtAgotado =
        (this.product.PV6 > 0 ? "Por llegar " : "") + "Disponible";
      this.agotado = false;
    }
  }

  public addToCart(product: Product, quantity) {
    alert("Muy pronto estara disponible!");
    // if (quantity == 0) return false;
    // if (product.SaldoG == 0) {
    //   this.snackBar.open(product.NombreItm + " no cuenta con stock", "×", {
    //     panelClass: "error",
    //     verticalPosition: "top",
    //     duration: 4000,
    //   });
    //   return false;
    // }

    // if (sessionStorage.getItem("tp") == null) {
    //   sessionStorage.setItem("tp", "TA");
    //   product.PVVenta = product.PV2;
    // } else {
    //   if (sessionStorage.getItem("tp") == "TA") {
    //     product.PVVenta = product.PV2;
    //   } else {
    //     product.PVVenta = product.PV3;
    //   }
    // }
    // this.cartService.addToCart(product, parseInt(quantity));
    // document.getElementById("carritoDialog").click()
  }

  public close(): void {
    // console.log('click')
    this.dialogRef.close();
  }

  public increment() {
    if (this.product.APedido) {
      this.counter = 1;
    } else {
      this.counter += 1;
      if (Number(this.counter) < Number(this.stockInicial) - 1) {
        this.txtAgotado =
          (this.product.PV6 > 0 ? "Por llegar " : "") + "Disponible";
        this.agotado = false;
      } else if (Number(this.counter) == Number(this.stockInicial) - 1) {
        this.txtAgotado =
          (this.product.PV6 > 0 ? "Por llegar " : "") + "Pocas Unidades";
        this.agotado = false;
      } else if (Number(this.counter) >= Number(this.stockInicial)) {
        this.counter = this.stockInicial;
        this.txtAgotado =
          (this.product.PV6 > 0 ? "Por llegar " : "") + "Agotado";
        this.agotado = false;
      }
    }
  }

  public decrement() {
    // if (this.counter > 1) {
    //   this.counter -= 1;
    // }
    if (this.product.APedido) {
      this.counter = 1;
    } else {
      //productItem.SaldoG <= counter && productItem.SaldoG != 0
      this.counter -= 1;
      if (this.counter == 0) {
        this.counter = 1;
      } else if (Number(this.counter) < Number(this.stockInicial) - 1) {
        this.txtAgotado = "Disponible";
        this.agotado = false;
      } else if (Number(this.counter) == Number(this.stockInicial) - 1) {
        this.txtAgotado = "Pocas Unidades";
        this.agotado = false;
      } else if (Number(this.counter) >= Number(this.stockInicial)) {
        this.txtAgotado = "Agotado";
        this.agotado = true;
      }
    }
  }

  // Add to cart
  public async buyNow() {
    await this.itemService.sumarClic(this.product.idItem);
    this.router.navigate(["/home/product", this.product.idItem]);
    this.close();
  }
  enviarMensajeWsp() {
    // console.log(this.productItem)
    const formData = {
      name: "Prueba",
      phone: "933288799",
      url: "novaplaza.pe/%23/home/product/967",
      date:
        "%0ACodigo: " +
        this.product.CodigoBarras +
        "%0ANombre Item: " +
        this.product.NombreItm +
        "%0AUrl: novaplaza.pe/%23/home/product/" +
        this.product.idItem,
    };

    const URL = `https://api.whatsapp.com/send?phone=${formData.phone}&text=Hola busco este Producto,%20${formData.date}%20&source=&data=`;
    window.open(URL, "_blank");
  }
}
